<template>
  <el-card>
    <div>
      <el-form :model="messageSetForm" label-width="auto">
        <el-form-item>
          <template #label>
            人工接管有效时间(单位秒)
            <el-tooltip placement="bottom" effect="light">
              <template #content>
                <div>
                  <p>开启人工接管状态后N秒后自动关闭人工接管状态</p>
                </div>
              </template>

              <i class="iconfont icon-tishi1"></i>
            </el-tooltip>
          </template>

          <el-input v-model="messageSetForm.artificial_active_time" type="number" :min="1" :max="3600" />
        </el-form-item>
        <div style="display: flex; justify-content: flex-end">
          <el-button @click="handleSave" type="primary">保存</el-button>
        </div>
      </el-form>
    </div>
  </el-card>
  <el-card style="margin-top: 10px;">
    <template #header>
      <div>
        消息提示设置
      </div>
    </template>
    <div class="p_item">
      <div class="mr_10">
        用户进入会话事件【消息角标提示】
        <el-tooltip class="box-item" placement="top-start">
          <template #content>
            <div class="m_color_e">
              此配置只针对用户第一次进入会话事件
            </div>
            <div>
              1. 开启状态，用户进入会话事件，未读消息提示会 +1
            </div>
            <div>
              2. 关闭状态，用户进入会话事件，未读消息提示不会增加
            </div>
          </template>
          <i class="iconfont icon-tishi1"></i>
        </el-tooltip>
      </div>
      <el-switch v-model="enter_direct_is_view_msg_num" inline-prompt :active-value="1" active-text="开"
        :inactive-value="0" inactive-text="关" />
    </div>
    <div class="p_item">
      <div class="mr_10">
        用户进入会话事件【消息提示音】
        <el-tooltip class="box-item" placement="top-start">
          <template #content>
            <div class="m_color_e">
              此配置只针对用户第一次进入会话事件
            </div>
            <div>
              1. 开启状态，用户进入会话事件，会播放提示音
            </div>
            <div>
              2. 关闭状态，用户进入会话事件，不会播放提示音
            </div>
          </template>
          <i class="iconfont icon-tishi1"></i>
        </el-tooltip>
      </div>
      <el-switch v-model="enter_direct_notice_flg" inline-prompt :active-value="1" active-text="开" :inactive-value="0"
        inactive-text="关" />
    </div>
    <div class="p_item">
      <div class="mr_10">
        新线索【提示音】
        <el-tooltip class="box-item" placement="top-start">
          <template #content>
            <div class="m_color_e">
              此配置只针对系统保存了用户线索提示音
            </div>
            <div>
              1. 开启状态，新线索会播放提示音
            </div>
            <div>
              2. 关闭状态，新线索不会播放提示音
            </div>
          </template>
          <i class="iconfont icon-tishi1"></i>
        </el-tooltip>
      </div>
      <el-switch v-model="new_customer_notice_flg" inline-prompt :active-value="1" active-text="开" :inactive-value="0"
        inactive-text="关" />
    </div>
    <div style="display: flex; justify-content: flex-end">
      <el-button @click="handleChangeMessageSetting" type="primary">保存</el-button>
    </div>

  </el-card>
  <el-card style="margin-top: 10px">
    <template #header>
      平台消息设置
      <el-tooltip class="box-item" placement="top-start">
        <template #content>
          <div>
            1. 控制页面最左侧的平台的显示或隐藏，勾选后代表显示。至少勾选一项
          </div>
          <div>
            2. 通过上移/下移控制显示顺序，默认进入系统选中第一个
          </div>
        </template>
        <i class="iconfont icon-tishi1"></i>
      </el-tooltip>
    </template>
    <div>
      <div class="p_item" v-for="(item, index) in menuListRef" :key="index">
        <el-checkbox v-model="item.checked" :true-value="true" :false-value="false" @change="handleChange(item)">
          <temlat> <i class="iconfont" :class="item.icon"></i>{{ item.desc }}</temlat>
        </el-checkbox>
        <div class="u_d">
          <el-button :link="true" type="primary" :disabled="index == 0" @click="handleUp(item)">
            上移
          </el-button>
          <el-button :link="true" type="primary" :disabled="index == (menuListRef.length - 1)"
            @click="handleDown(item)">
            下移
          </el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import {
  props,
  reactive,
  computed,
  ref,
  inject,
  onMounted,
  nextTick,
  onUnmounted,
  watch,
} from "vue";
import * as echarts from "echarts";
import { useStore } from "vuex";
import { changeArtificialActiveTime } from "@/api/userapi";
import { ElMessage } from 'element-plus'
import { changeMessageSetting } from "@/api/chatapi";
export default {
  name: "myleads_today",

  props: { title: { type: String, default: "" } },
  setup(props) {
    const activeTab = inject("activeTab");

    //进入会话角标提示开关
    const enter_direct_is_view_msg_num = ref(0)
    //进入会话提示音状态
    const enter_direct_notice_flg = ref(0)
    //新线索提示音
    const new_customer_notice_flg = ref(0)

    const store = useStore();
    const userInfo = computed(() => {
      return store.state.user.user;
    });

    const menuList = store.state.user.user_plat_msg_menu

    const menuListRef = ref([...menuList])

    let messageSetFormState = {
      artificial_active_time: 0,
    };
    let messageSetForm = reactive({
      ...messageSetFormState,
    });



    // --- 方法 --------

    //  changeMessageSetting
    const handleChangeMessageSetting = async () => {
      // 1 进入会话消息角标提示 value: 1开启, 0 = 关闭
      // 2 进入会话提示音状态 value: 1开启, 0 = 关闭
      // 3 新线索提示音状态 value: 1开启, 0 = 关闭
      let data = [
        {
          "type": 1,
          "value": enter_direct_is_view_msg_num.value
        }, {
          "type": 2,
          "value": enter_direct_notice_flg.value
        }, {
          "type": 3,
          "value": new_customer_notice_flg.value
        }
      ]
      changeMessageSetting(data)
      //延迟自动刷新一下
      setTimeout(() => {
        handleInitPage()
      }, 5000);
    }


    const handleChange = (v) => {
      if (v.checked === false) {
        //检查选中的条数
        let fidx = menuListRef.value.findIndex(item => item.checked)
        if (fidx < 0) {
          ElMessage.error('至少显示一个平台')
          v.checked = true
          return
        }
      }
      store.dispatch('user/setPlatmsgMenu', menuListRef.value)
    }
    const handleUp = (item) => {
      let index = menuListRef.value.findIndex(_item => _item.value == item.value)
      if (index <= 0) {
        return
      }
      //上一个元素
      let preItem = menuListRef.value[index - 1]
      menuListRef.value.splice(index - 1, 2, item, preItem)
      store.dispatch('user/setPlatmsgMenu', menuListRef.value)
    }

    const handleDown = (item) => {
      let index = menuListRef.value.findIndex(_item => _item.value == item.value)
      if (index >= menuListRef.value?.length - 1) {
        return
      }
      let nextItem = menuListRef.value[index + 1]
      menuListRef.value.splice(index, 2, nextItem, item)
      store.dispatch('user/setPlatmsgMenu', menuListRef.value)
    }


    const handleSave = () => {
      let data = {
        artificial_active_time: messageSetForm.artificial_active_time,
      };
      changeArtificialActiveTime(data);
    };
    const handleInitPage = () => {
      messageSetForm.artificial_active_time =
        userInfo.value.artificial_active_time;
      enter_direct_is_view_msg_num.value = userInfo.value.enter_direct_is_view_msg_num || 0
      enter_direct_notice_flg.value = userInfo.value.enter_direct_notice_flg || 0
      new_customer_notice_flg.value = userInfo.value.new_customer_notice_flg || 0
    };
    onMounted(handleInitPage);

    watch(
      () => activeTab.value,
      (newValue) => {
        if (newValue == '2') {
          handleInitPage()
        }
      })
    return {
      messageSetForm,
      userInfo,
      activeTab,
      menuListRef,
      handleSave,
      handleUp,
      handleDown,
      handleChange,
      handleChangeMessageSetting,
      enter_direct_is_view_msg_num,
      enter_direct_notice_flg,
      new_customer_notice_flg,
    };
  },
};
</script>
<style lang="scss" scoped>
.p_item {
  padding: 5px;
  display: flex;
  align-items: center;

  .u_d {
    margin-left: 2px;
    display: flex;
    align-items: center;
  }
}

.p_item:not(:first-child) {
  border-top: 1px dashed #9ea0a3;

}
</style>